<template lang="html">
  <d-container fluid>
    <d-row>
      <!-- Project Status -->
      <d-col lg="12" md="12" sm="12">
        <project-status />
      </d-col>
    </d-row>
    <d-row>
      <!-- Ticket -->
      <d-col lg="4" md="6" sm="12" class="mb-4">
        <d-card class="card-small">

          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">Novo Chamado</h6>
            <div class="block-handle"></div>
          </d-card-header>

          <d-card-body>
            <ticket-form />
          </d-card-body>
        </d-card>
      </d-col>
      <!-- Ticket -->
      <d-col lg="8" md="6" sm="12" class="mb-4">
        <d-card class="card-small">

          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <h6 class="m-0">Lista dos Chamados</h6>
            <div class="block-handle"></div>
          </d-card-header>

          <d-card-body>
            <ticket-client-table :tickets="tickets.list" />
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import TicketForm from '_modules/ticket/components/TicketForm.vue';
import ProjectStatus from '_common/components/dashboard/ProjectStatus.vue';
import TicketClientTable from '_modules/ticket/components/TicketClientListTable.vue';

export default {
  name: 'dashboard-customer',
  components: {
    TicketForm,
    ProjectStatus,
    TicketClientTable,
  },
  computed: {
    tickets() {
      const { ticketList } = this.$store.state.ticket;
      if (ticketList && ticketList.list.length) {
        return ticketList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  data() {
    return {
      pagination: {
        search: '',
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  methods: {
    ...mapActions([
      'getTicketList',
    ]),
    getList() {
      this.getTicketList(this.pagination);
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
</style>
